export const environment = {
  production: false,
  envName: 'development',
  auth: {
    audience: ''
  }
};
